























































import { Component, Vue, Prop } from 'vue-property-decorator'
import TestStatusList from '../TestStatusList/TestStatusList.vue'
import Icon from '../../shared/Icon/Icon.vue'
import loadingGif from '../../../assets/img/loading.gif'
import { uniq } from 'lodash-es'
import { ProjectCardData } from '../../../types/interfaces'
import ellipsis from 'text-ellipsis'
import { stripHtml } from '../../../filters'

@Component({ components: { TestStatusList, Icon } })
export default class ProjectCard extends Vue {
  @Prop() readonly project!: ProjectCardData
  @Prop() readonly reports!: []

  loading = false
  loadingGif = loadingGif

  get ellipsis () {
    return ellipsis
  }

  get stripHtml () {
    return stripHtml
  }

  get audienceNames () {
    return new Set(Object.values(this.project.audiences).map(audience => audience.title))
  }

  get uniqueTags () {
    return uniq(this.project.tags)
  }

  get hasReports () {
    return this.reports.length > 0
  }

  get audienceString () {
    return true
  }
}
